import { useMemo } from 'react';
import { TagPill } from './TagPill';
import type { DefaultTagDefinition } from '../../types/tags';
import './TagsList.css';

interface TagsListProps {
  definitions: DefaultTagDefinition[];
  tagsByName: Record<string, string[]>;
  onTagPress: (tagName: string) => void;
}

export function TagsList({ definitions, tagsByName, onTagPress }: TagsListProps) {
  // Sort definitions by displayOrder and separate tags with values from empty tags
  const { tagsWithValues, emptyTags } = useMemo(() => {
    const sortedDefinitions = [...definitions].sort((a, b) => a.displayOrder - b.displayOrder);

    const withValues = sortedDefinitions.filter(
      (def) => (tagsByName[def.tagName] || []).length > 0
    );
    const empty = sortedDefinitions.filter(
      (def) => (tagsByName[def.tagName] || []).length === 0
    );

    return { tagsWithValues: withValues, emptyTags: empty };
  }, [definitions, tagsByName]);

  return (
    <div className="tags-list">
      <h3 className="tags-list__label">Tags</h3>
      <div className="tags-list__pills">
        {/* Tags with values */}
        {tagsWithValues.map((definition) => (
          <TagPill
            key={definition.tagName}
            tagName={definition.tagName}
            values={tagsByName[definition.tagName] || []}
            onPress={() => onTagPress(definition.tagName)}
          />
        ))}

        {/* Empty tags */}
        {emptyTags.map((definition) => (
          <TagPill
            key={definition.tagName}
            tagName={definition.tagName}
            values={[]}
            onPress={() => onTagPress(definition.tagName)}
          />
        ))}
      </div>
    </div>
  );
}
